module.exports = __webpack_public_path__ + "img/taken_statistics.dde4ab31.svg";